import React, { Dispatch, MouseEventHandler, SetStateAction } from 'react';

import TranslationHelper from '../../../../../helpers/TranslationHelper';
import { useDebounceEffect } from '../../../../../helpers/hooks';

import { DEBOUNCE_LOW } from '../../../../../constants/DebounceValues';

import { lowerCaseFilter } from '../../../helpers/filterObjects';

import { IListObjectInitialState } from '../../../../../components/TransferList/CommonTransferList';
import ProductCustomList from '../CustomList/ProductCustomList';
import { IProductAssignment, IProductFilterInitialState } from '../../../types';

interface IOwnProps {
    objects: IListObjectInitialState<IProductAssignment>;
    setObjects: React.Dispatch<
        Partial<IListObjectInitialState<IProductAssignment>>
    >;
    checked: IProductAssignment[];
    setChecked: Dispatch<SetStateAction<IProductAssignment[]>>;
    filter: IProductFilterInitialState;
    setFilter: React.Dispatch<Partial<IProductFilterInitialState>>;
    handleToggle: (value: IProductAssignment) => MouseEventHandler;
}

const RightList = ({
    objects,
    setObjects,
    checked,
    setChecked,
    filter,
    setFilter,
    handleToggle,
}: IOwnProps) => {
    const assignedTitle = TranslationHelper.translate('objects.assigned');

    const { nameAssigned } = filter;
    const { assignedObjects, filteredAssignedObjects } = objects;
    useDebounceEffect(
        () => {
            handleChangeNameAssigned();
        },
        [nameAssigned, assignedObjects],
        DEBOUNCE_LOW
    );

    const handleChangeNameAssigned = () => {
        if (nameAssigned === '') {
            setObjects({ filteredAssignedObjects: assignedObjects });
            return;
        }
        const filteredObjects = assignedObjects.filter((object) =>
            lowerCaseFilter(object, nameAssigned)
        );
        setObjects({ filteredAssignedObjects: filteredObjects });
    };

    return (
        <ProductCustomList
            loaded={true}
            nameInput={{
                name: nameAssigned,
                setName: (name) => setFilter({ nameAssigned: name }),
            }}
            title={assignedTitle}
            items={filteredAssignedObjects}
            handleToggle={handleToggle}
            checked={checked}
            setChecked={setChecked}
            tooltipTitle="You can use * as a wildcard."
        />
    );
};

export default RightList;
